import http from '@util/http';
import {incubator} from '@api/req';

export async function querySaveIncuDatabase(params) {
  return http.post(incubator.INCUBATOR_DATEBASE_SAVE, params);
}

export async function queryDeleteIncuDatabase(params) {
  return http.get(incubator.INCUBATOR_DATEBASE_DElETE, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/database.js